"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionModelFieldFileTool = exports.ModelMutatorFileTool = void 0;
const core_api_1 = require("@ikegps/core-api");
const collection_field_1 = require("../collection.field");
class ModelMutatorFileTool extends collection_field_1.ModelMutator {
    manual(newFileTool) {
        if (newFileTool == null) {
            this.state.setFieldValue(this.field.id, null);
        }
        else {
            this.state.setFieldValue(this.field.id, {
                filename: newFileTool.filename,
                attachmentId: newFileTool.attachmentId,
                size: newFileTool.size,
                metadata: newFileTool.metadata
            });
        }
    }
    copy(from) {
        return false;
    }
}
exports.ModelMutatorFileTool = ModelMutatorFileTool;
class CollectionModelFieldFileTool extends collection_field_1.CollectionModelField {
    static isFileToolField(f) {
        return f.schema.type === CollectionModelFieldFileTool.TYPE;
    }
    get Mutator() {
        if (this._Mutator == null) {
            this._Mutator = new ModelMutatorFileTool(this);
        }
        return this._Mutator;
    }
    get value() {
        const stateValue = this.stateValue;
        if (stateValue == null) {
            return null;
        }
        return this.stateValue.filename;
    }
    get displayValue() {
        const stateValue = this.stateValue;
        if (stateValue == null) {
            return null;
        }
        return this.stateValue.filename;
    }
    get attachmentId() {
        const stateValue = this.stateValue;
        if (stateValue == null) {
            return null;
        }
        return this.stateValue.attachmentId;
    }
    get size() {
        const stateValue = this.stateValue;
        if (stateValue == null) {
            return null;
        }
        return this.stateValue.size;
    }
    get metadata() {
        const stateValue = this.stateValue;
        if (stateValue == null) {
            return null;
        }
        return this.stateValue.metadata;
    }
    hasValue() {
        const value = this.value;
        if (value == null || value === '') {
            return false;
        }
        return true;
    }
}
exports.CollectionModelFieldFileTool = CollectionModelFieldFileTool;
CollectionModelFieldFileTool.TYPE = core_api_1.IkeFieldType.FILE_TOOL;
//# sourceMappingURL=file.tool.field.js.map